import { render } from "./BelarusPage.vue?vue&type=template&id=0f6b78bb&scoped=true"
import script from "./BelarusPage.vue?vue&type=script&lang=js"
export * from "./BelarusPage.vue?vue&type=script&lang=js"

import "./BelarusPage.vue?vue&type=style&index=0&id=0f6b78bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6b78bb"]])

export default __exports__